/* Detailing1 PWA-Push-Kern — ausgelagert aus snippets/d1-pwa-core.liquid (Paket C 2026-09). Konfiguration: <script type=application/json id=d1-pwa-core-cfg> */
(function(){
  // Konfiguration kommt aus snippets/d1-pwa-core.liquid (JSON-Tag), Paket C 2026-09
  var cfgEl=document.getElementById('d1-pwa-core-cfg');if(!cfgEl)return;var C;try{C=JSON.parse(cfgEl.textContent);}catch(e){return;}
  var D1_CUST=C.customer||null;
  var ICON=C.icon;
  var CFG=C.cfg;var TXT=C.txt;
  var LS={pv:'d1_pv',at:'d1_softask_at',ct:'d1_softask_count'};
  var supported=('serviceWorker' in navigator)&&('PushManager' in window)&&('Notification' in window);
  var standalone=(navigator.standalone===true)||(window.matchMedia&&matchMedia('(display-mode: standalone)').matches);
  var isIOS=/iphone|ipad|ipod/i.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);

  function urlB64(s){var p='='.repeat((4-s.length%4)%4);var b=(s+p).replace(/-/g,'+').replace(/_/g,'/');var r=atob(b);return Uint8Array.from([...r].map(c=>c.charCodeAt(0)));}
  function waitActive(reg){if(reg.active)return Promise.resolve(reg.active);return new Promise(function(res){var w=reg.installing||reg.waiting;if(!w)return res(reg.active);w.addEventListener('statechange',function(){if(this.state==='activated')res(this);});if(reg.active)res(reg.active);});}
  function intercomId(){return (window.intercomSettings&&window.intercomSettings.user_id)||(D1_CUST&&D1_CUST.id)||null;}
  function intercomEmail(){return (window.intercomSettings&&window.intercomSettings.email)||(D1_CUST&&D1_CUST.email)||null;}

  // Manifest same-origin via App Proxy in den <head> hängen.
  if(!document.querySelector('link[rel="manifest"]')){var l=document.createElement('link');l.rel='manifest';l.href='/apps/push/manifest.webmanifest';document.head.appendChild(l);}

  // ---- Subscribe (an User-Geste hängen; iOS verlangt das) ----
  async function enablePush(source){
    if(!supported) {alert('Benachrichtigungen werden hier nicht unterstützt.');return false;}
    if(isIOS&&!standalone){alert('Bitte zuerst über „Teilen → Zum Home-Bildschirm" installieren, dann in der App aktivieren.');return false;}
    // iOS/Safari: requestPermission MUSS direkt in der User-Geste laufen — VOR allen awaits,
    // sonst ist die Geste nach SW-Register/Activate verbraucht und der Prompt erscheint nicht.
    var perm=await Notification.requestPermission();
    if(perm!=='granted')return false;
    var reg=await navigator.serviceWorker.register('/apps/push/sw.js',{scope:'/apps/push/'});
    await waitActive(reg);
    var cfg=await (await fetch('/apps/push/config',{credentials:'include'})).json();
    var sub=await reg.pushManager.subscribe({userVisibleOnly:true,applicationServerKey:urlB64(cfg.vapidPublicKey)});
    await fetch('/apps/push/subscribe',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'include',
      body:JSON.stringify({subscription:sub,intercomUserId:intercomId(),email:intercomEmail(),consent:{granted:true},source:source||'manual',locale:document.documentElement.lang||null,installSource:standalone?'pwa':'browser'})});
    try{(window.dataLayer=window.dataLayer||[]).push({event:'d1_push_enabled',d1_push_source:source||'manual'});}catch(e){}
    return true;
  }
  async function disablePush(){
    try{var reg=await navigator.serviceWorker.getRegistration('/apps/push/');if(!reg)return;var sub=await reg.pushManager.getSubscription();if(!sub)return;
      await fetch('/apps/push/unsubscribe',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'include',body:JSON.stringify({endpoint:sub.endpoint})});
      await sub.unsubscribe();}catch(e){}
  }
  window.d1EnablePush=function(){return enablePush('manual');};
  window.d1DisablePush=disablePush;

  // ---- Soft-Ask-Karte (UX-Vorstufe, löst selbst keinen Consent aus) ----
  function showSoftAsk(){
    if(document.getElementById('d1ask'))return;
    var card=document.createElement('div');card.id='d1ask';
    card.innerHTML='<div class="d1-row"><img class="d1-ico" src="'+ICON+'" alt="Detailing1"><div><div class="d1-tt">'+TXT.title+'</div><div class="d1-su">'+TXT.body+'</div></div></div>'+
      '<div class="d1-btns"><button class="d1-allow">Erlauben</button><button class="d1-later">Später</button></div>';
    document.body.appendChild(card);
    requestAnimationFrame(function(){card.classList.add('d1-in');});
    function close(){card.classList.remove('d1-in');setTimeout(function(){card.remove();},340);}
    function cooldown(){try{var c=parseInt(localStorage.getItem(LS.ct)||'0',10)+1;localStorage.setItem(LS.ct,String(c));localStorage.setItem(LS.at,String(Date.now()));}catch(e){}}
    card.querySelector('.d1-allow').addEventListener('click',async function(){var ok=await enablePush('soft-ask');if(!ok)cooldown();close();});
    card.querySelector('.d1-later').addEventListener('click',function(){cooldown();close();});
  }

  // ---- Installierte App (iOS/Android-PWA): native Abfrage DIREKT, ohne Soft-Ask ----
  // iOS erlaubt requestPermission nur in einer User-Geste -> der allererste Tap fragt nativ.
  // Android/Desktop-PWA fragt sofort beim Öffnen; Erst-Tap ist dort der Fallback (Quiet-UI).
  function nativeAsk(){
    if(!CFG.pwaAsk||!supported||Notification.permission!=='default')return;
    // 'd1_pwa_ask_at2' (nicht 'at'): bewusster Key-Wechsel — die pointerdown-Ära hat
    // Cooldowns gesetzt, ohne dass je ein Prompt erschien; alte Installs heilen so selbst.
    var tries=0,at=0;try{tries=parseInt(localStorage.getItem('d1_pwa_ask_ct')||'0',10);at=parseInt(localStorage.getItem('d1_pwa_ask_at2')||'0',10);}catch(e){}
    if(tries>=CFG.askMax)return;                             // Deckel: danach dauerhaft Ruhe
    if(at&&(Date.now()-at)<CFG.askCoolD*86400000)return;     // Cooldown zwischen Versuchen (Default 90 Tage)
    function bump(){try{localStorage.setItem('d1_pwa_ask_ct',String(tries+1));localStorage.setItem('d1_pwa_ask_at2',String(Date.now()));}catch(e){}}
    if(!isIOS){bump();enablePush('pwa-first-open');}
    // WICHTIG: 'click', NICHT 'pointerdown' — WebKit vergibt User-Activation erst mit der
    // ABGESCHLOSSENEN Geste (touchend/click); auf pointerdown unterdrückt iOS den Prompt still.
    var asking=false;
    function onTap(){
      if(asking||Notification.permission!=='default'){document.removeEventListener('click',onTap,true);return;}
      asking=true;
      var done=function(){
        asking=false;
        if(Notification.permission!=='default'){
          if(isIOS)bump();                                   // iOS: Versuch zählt erst, wenn der Prompt real beantwortet wurde
          document.removeEventListener('click',onTap,true);
        }else if(!isIOS){
          document.removeEventListener('click',onTap,true);  // Android: ein Gesten-Retry reicht (Quiet-UI)
        }                                                     // iOS + weiter 'default': Prompt erschien nie -> nächster Tap versucht erneut
      };
      enablePush(isIOS?'pwa-first-gesture':'pwa-gesture-retry').then(done,done);
    }
    document.addEventListener('click',onTap,true);
  }

  // Browser (Android/Desktop): direkt der NATIVE Prompt statt der Karte (Jasper-Entscheid).
  // Quiet-UI-Fallback: drückt Chrome den Dialog leise weg, holt der nächste Tap ihn voll nach.
  function browserNativeAsk(){
    if(Notification.permission!=='default')return;
    function cool(){try{var c=parseInt(localStorage.getItem(LS.ct)||'0',10)+1;localStorage.setItem(LS.ct,String(c));localStorage.setItem(LS.at,String(Date.now()));}catch(e){}}
    var done=function(){
      if(Notification.permission!=='default')return;   // beantwortet -> fertig, kein Cooldown nötig
      document.addEventListener('click',function(){
        if(Notification.permission==='default')enablePush('browser-native-gesture');
      },{capture:true,once:true});
      cool();                                          // nicht beantwortet -> Cooldown-Stufe zählt
    };
    enablePush('browser-native').then(done,done);
  }

  function maybeSoftAsk(){
    if(!CFG.softask)return;                        // per d1_pwa.config deaktivierbar
    if(!supported||Notification.permission!=='default')return;
    if(isIOS&&!standalone)return;                 // im Safari-Tab übernimmt das A2HS-Banner
    try{
      var c=parseInt(localStorage.getItem(LS.ct)||'0',10);if(c>=3)return;
      var at=parseInt(localStorage.getItem(LS.at)||'0',10);var wait=(c>=2?60:c===1?30:7)*86400000;
      if(at&&(Date.now()-at)<wait)return;
      var pv=parseInt(localStorage.getItem(LS.pv)||'0',10);if(pv<CFG.minPv)return;   // N Page Views
    }catch(e){return;}
    setTimeout(CFG.askStyle==='card'?showSoftAsk:browserNativeAsk,CFG.delayS*1000);  // + N Sekunden Verweildauer
  }

  // Page-View-Zähler
  try{localStorage.setItem(LS.pv,String(parseInt(localStorage.getItem(LS.pv)||'0',10)+1));}catch(e){}

  // ---- Deep-Link + Badge-Reset ----
  function openConv(convId){if(window.Intercom){convId?Intercom('showConversation',convId):Intercom('show');}}
  navigator.serviceWorker&&navigator.serviceWorker.addEventListener('message',function(e){if(e.data&&e.data.type==='open-conversation')openConv(e.data.convId);});
  (function(){var m=location.search.match(/[?&]ic_conv=([^&]+)/);if(m)setTimeout(function(){openConv(decodeURIComponent(m[1]));},1200);})();
  function clearBadge(){try{navigator.clearAppBadge&&navigator.clearAppBadge();}catch(e){}}
  clearBadge();document.addEventListener('visibilitychange',function(){if(!document.hidden)clearBadge();});

  function boot(){if(standalone){nativeAsk();}else{maybeSoftAsk();}}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
})();
